<template>
  <div class="stand-list" :class="{ 'permission-embed': permissionMode }" v-loading="loading">
    <div class="list-main">
      <div class="from totalHeight list-form">
        <div class="btn-wrap">
          <OmsForm :form-config="searchFormConfig" />
          <div class="operation">
            <div class="btn">
              <Checkbox
                v-if="permissionMode"
                v-model="isPermissionExclude"
                class="permission-exclude-check"
              >
                排除
              </Checkbox>
              <OmsButton :btn-config="filterBtnConfig" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="!permissionMode" class="btn totalHeight list-btn fix">
        <OmsButton :btn-config="btnConfig" />
      </div>
      <div class="list-table">
        <div class="tableBox" v-loading="agTableConfig.agLoading">
          <OmsAgTable
            ref="agGridChild"
            :options="options"
            :ag-table-config="agTableConfig"
            @on-page-change="pageChange"
            @on-page-size-change="pageSizeChange"
            @on-row-dblclick="onRowDblclick"
            @on-selection-change="onSelectionChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setFormDataFunMixin } from '@/assets/js/mixins/setFormData';

const CMD_BTN_TEXT = {
  actionADD: '新增',
  actionDELETE: '删除',
  actionSUBMIT: '审核',
  actionUNSUBMIT: '取消审核',
  actionGROUPSUBMIT: '批量提交',
  actionVOID: '作废',
  actionBATCHMODIFY: '批量修改',
  actionIMPORT: '导入',
  actionEXPORT: '导出',
  actionView: '查看',
  actionPRINT: '打印',
};

export default {
  name: 'StandList',
  mixins: [setFormDataFunMixin],
  props: {
    permissionMode: {
      type: Boolean,
      default: false,
    },
    permissionTable: {
      type: String,
      default: '',
    },
    permissionTableId: {
      type: [String, Number],
      default: '',
    },
    permissionConditions: {
      type: Array,
      default: () => [],
    },
    // 权限弹窗额外查询条件，合并进 QueryList fixedcolumns
    permissionQuery: {
      type: Object,
      default: null,
    },
    hideAddAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      tableName: 'CP_C_MALL',
      tableId: null,
      pageDesc: '商场档案',
      webConf: {},
      akColname: '', // tabth 中 isak 为 true 的列名，用作权限勾选回显 label
      prevPermissionSelection: [],
      isPermissionExclude: false,
      localPermissionConds: [],
      selection: [],
      options: {
        datas: {},
        status4css: [],
      },
      searchFormConfig: {
        formData: [],
        formValue: {},
        formValueName: {},
        ruleValidate: {},
        isGrid: true,
      },
      filterBtn: {
        buttons: [
          {
            key: 'addAll',
            text: '添加全部',
            type: 'primary',
            btnclick: () => {
              this.PERMISSION_ADD_ALL();
            },
          },
          {
            text: '查找',
            type: 'primary',
            icon: 'md-search',
            btnclick: () => {
              this.agTableConfig.pagenation.current = 1;
              this.getList();
            },
          },
          {
            text: '重置',
            icon: 'md-refresh',
            btnclick: () => {
              this.resetForm();
            },
          },
        ],
      },
      btnConfig: {
        typeAll: 'default',
        buttons: [],
      },
      agTableConfig: {
        isIndex: true,
        agLoading: false,
        columnDefs: [],
        rowData: [],
        pageShow: true,
        pageInline: true,
        tableHeight: '300px',
        pagenation: {
          total: 0,
          pageSize: 30,
          current: 1,
          pageSizeOpts: [10, 20, 30, 50, 100, 200, 500],
        },
      },
    };
  },
  computed: {
    filterBtnConfig() {
      const buttons = (this.filterBtn.buttons || [])
        .filter((btn) => !(this.hideAddAll && btn.key === 'addAll'))
        .map((btn) => {
          if (btn.key === 'addAll') {
            return {
              ...btn,
              text: this.isPermissionExclude ? '排除全部' : '添加全部',
            };
          }
          return btn;
        });
      return {
        ...this.filterBtn,
        buttons,
      };
    },
  },
  watch: {
    permissionTable: {
      handler(val) {
        if (this.permissionMode && val) {
          this.tableName = val;
          this.tableId = this.permissionTableId;
          this.initPermissionEmbed();
        }
      },
      immediate: true,
    },
    permissionConditions: {
      handler(val) {
        if (!this.permissionMode) return;
        const next = val || [];
        if (!_.isEqual(next, this.localPermissionConds)) {
          this.localPermissionConds = _.cloneDeep(next);
          // 右侧「移除选中行/全部」后同步勾选快照，否则再勾选同一行不会写入结果栏
          this.prunePrevPermissionSelection();
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.permissionMode) {
      this.getTableQuery();
    }
  },
  activated() {
    if (!this.permissionMode) {
      // $utils.setTableHeight(this, 165);
      // $utils.onresizes(this, 0);
    }
  },
  methods: {
    initPermissionEmbed() {
      this.prevPermissionSelection = [];
      this.isPermissionExclude = false;
      this.akColname = '';
      this.localPermissionConds = _.cloneDeep(this.permissionConditions || []);
      this.getTableQuery(true);
    },
    /** 收集当前权限条件中的 id 集合 */
    collectPermissionCondIds() {
      const ids = new Set();
      (this.localPermissionConds || []).forEach((group) => {
        if (!(group && group.length === 1 && group[0].colname === 'id')) return;
        String(group[0].value || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .forEach((id) => ids.add(String(id)));
      });
      return ids;
    },
    /** 条件被外部删减后，去掉 prev 中已不在条件里的勾选项，并取消表格对应勾选 */
    prunePrevPermissionSelection() {
      const idsInConds = this.collectPermissionCondIds();
      const removedIds = [];
      this.prevPermissionSelection = (this.prevPermissionSelection || []).filter((item) => {
        const row = this.flattenSelectionRows([item])[0];
        const id = row ? this.getPermissionRowId(row) : '';
        const keep = id && idsInConds.has(id);
        if (id && !keep) removedIds.push(id);
        return keep;
      });
      // 条件已空：取消表格全部勾选；否则只取消被移除的 id
      if (!idsInConds.size) {
        this.clearPermissionGridSelectionByIds(null, true);
      } else if (removedIds.length) {
        this.clearPermissionGridSelectionByIds(removedIds);
      }
    },
    /**
     * 取消表格勾选
     * @param {string[]} ids 指定 id；clearAll 时忽略
     * @param {boolean} clearAll 是否取消全部勾选
     */
    clearPermissionGridSelectionByIds(ids, clearAll = false) {
      const idSet = clearAll ? null : new Set((ids || []).map(String));
      if (!clearAll && (!idSet || !idSet.size)) return;
      const ag = this.$refs.agGridChild;
      const api = ag && ag.$refs && ag.$refs.agGrid && ag.$refs.agGrid.api;
      if (!api || typeof api.forEachNode !== 'function') return;
      this._syncingPermissionSelection = true;
      api.forEachNode((node) => {
        if (!node || !node.data || !node.isSelected || !node.isSelected()) return;
        if (!clearAll) {
          const row = this.flattenSelectionRows([node.data])[0];
          const id = row ? this.getPermissionRowId(row) : '';
          if (!(id && idSet.has(id))) return;
        }
        if (typeof node.setSelected === 'function') {
          node.setSelected(false);
        }
      });
      this.$nextTick(() => {
        this._syncingPermissionSelection = false;
      });
    },
    updateLocalPermissionConds(payload) {
      const { isInit, isId, isDel, data } = payload;
      if (isInit) {
        this.localPermissionConds = _.cloneDeep(data || []);
        return;
      }
      if (isId) {
        this.localPermissionConds = this.localPermissionConds.concat(data);
        return;
      }
      if (isDel) {
        if (!Array.isArray(data)) return;
        if (data.length) {
          const next = this.localPermissionConds.filter((i, index) => !data.includes(index));
          this.$set(this, 'localPermissionConds', next);
        } else {
          this.$set(this, 'localPermissionConds', []);
        }
        return;
      }
      this.$set(this.localPermissionConds, this.localPermissionConds.length, data);
    },
    normalizeSearchField(item) {
      const field = {
        ...item,
        name: item.coldesc || item.name,
        display: item.display || 'text',
      };
      if (field.display === 'OBJ_FK' && field.fkobj) {
        const { fkobj } = field;
        const fkdisplay = fkobj.searchmodel || 'drp';
        field.isfk = true;
        field.fkdisplay = fkdisplay;
        field.reftable = fkobj.reftable;
        field.reftableid = fkobj.reftableid;
        if (fkdisplay === 'mrp') {
          field.multiple = true;
          field.pid = [];
        }
      } else if (field.display === 'OBJ_SELECT' && field.combobox) {
        field.display = 'select';
        field.multiple = true;
        field.filterable = true;
      }
      return field;
    },
    parseSelectDefaultValue(defaultRaw) {
      if (defaultRaw === undefined || defaultRaw === null || defaultRaw === '') return [];
      if (Array.isArray(defaultRaw)) {
        return defaultRaw.map((v) => this.resolveSelectOptionValue(v)).filter((v) => v !== '' && v !== null && v !== undefined);
      }
      return String(defaultRaw).split(',').map((s) => s.trim()).filter(Boolean);
    },
    patchSearchFormSelectFields(formList = []) {
      const defaultMap = {};
      (formList || []).forEach((field) => {
        if (!field || !field.colname) return;
        if (field.default === undefined || field.default === null || field.default === '') return;
        defaultMap[field.colname] = field.default;
      });
      (this.searchFormConfig.formData || []).forEach((item) => {
        if (item.style !== 'select') return;
        const colname = item.colname || item.value;
        if (!colname) return;
        const initVal = this.parseSelectDefaultValue(defaultMap[colname]);
        if (defaultMap[colname] !== undefined) {
          item.default = defaultMap[colname];
        }
        this.$set(this.searchFormConfig.formValue, colname, initVal);
        const options = item.options || [];
        if (initVal.length) {
          this.$set(this.searchFormConfig.formValueName, colname, this.buildSelectDisplayLabels(initVal, options));
        }
        const originSelectChange = item.selectChange;
        item.selectChange = (val) => {
          const labels = this.buildSelectDisplayLabels(val, options);
          this.$set(this.searchFormConfig.formValueName, colname, labels);
          if (typeof originSelectChange === 'function') {
            originSelectChange(val);
          }
        };
      });
    },
    buildSelectDisplayLabels(val, options = []) {
      if (val === '' || val === null || val === undefined) return '';
      const list = Array.isArray(val) ? val : [val];
      return list.map((v) => this.resolveSelectOptionLabel(v, options)).filter(Boolean).join(',');
    },
    calcPermissionTableHeight() {
      this.$nextTick(() => {
        const listMain = this.$el && this.$el.querySelector('.list-main');
        if (!listMain) return;
        const listForm = this.$el.querySelector('.list-form');
        const listBtn = this.$el.querySelector('.list-btn');
        let topHeight = 0;
        if (listForm) topHeight += listForm.offsetHeight;
        if (listBtn) topHeight += listBtn.offsetHeight;
        const height = Math.max(listMain.clientHeight - topHeight - 45, 120);
        this.agTableConfig.tableHeight = `${height}px`;
      });
    },
    getTableQuery(isPermissionEmbed) {
      const formData = new FormData();
      formData.append('table', this.tableName);
      formData.append('getcmd', 'y');
      this.loading = true;
      this.service.common.getTableQuery(formData).then((res) => {
        if (res.data.code === 0) {
          const { datas, tabcmd } = res.data;
          this.tableId = datas.tableid;
          this.pageDesc = (tabcmd && tabcmd.desc) || this.pageDesc;
          this.webConf = datas.webconf || {};
          if (datas.status4css) {
            this.options.status4css = datas.status4css;
          }
          const formList = (datas.dataarry || []).map((item) => this.normalizeSearchField(item));
          this.formCommonFun('searchFormConfig', formList, 6);
          this.searchFormConfig.isGrid = true;
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.patchSearchFormSelectFields(formList);
              this.getList();
            });
          });
          if (!isPermissionEmbed) {
            this.buildBtnConfig(tabcmd);
          } else {
            this.btnConfig.buttons = [];
          }
        }
      }).finally(() => {
        this.loading = false;
        if (isPermissionEmbed) {
          this.calcPermissionTableHeight();
        }
      });
    },
    buildBtnConfig(tabcmd) {
      if (!tabcmd || !tabcmd.cmds) {
        return;
      }
      this.btnConfig.buttons = tabcmd.cmds.map((cmd, index) => ({
        text: CMD_BTN_TEXT[cmd] || cmd,
        webname: cmd,
        isShow: tabcmd.prem[index],
        action: tabcmd.paths[index],
        btnclick: () => {
          this.handleCmdClick(cmd, tabcmd.paths[index]);
        },
      }));
    },
    handleCmdClick(cmd, action) {
      switch (cmd) {
        case 'actionADD':
          this.openObject('New');
          break;
        case 'actionDELETE':
          this.handleDelete(action);
          break;
        case 'actionEXPORT':
          this.handleExport();
          break;
        default:
          if (action) {
            this.$Message.info('功能待扩展');
          }
          break;
      }
    },
    getSearchParams() {
      const { pagenation } = this.agTableConfig;
      const searchdata = {
        table: this.tableName,
        startindex: (pagenation.current - 1) * pagenation.pageSize,
        range: pagenation.pageSize,
        fixedcolumns: {},
        column_include_uicontroller: true,
        isolr: false,
      };
      const val = this.searchFormConfig.formValue || {};
      Object.keys(val).forEach((key) => {
        const itemVal = val[key];
        if (itemVal === '' || itemVal === null || itemVal === undefined) {
          return;
        }
        if (typeof itemVal === 'boolean') {
          searchdata.fixedcolumns[key] = itemVal ? 'Y' : 'N';
        } else if (Array.isArray(itemVal) && itemVal.length) {
          searchdata.fixedcolumns[key] = itemVal;
        } else if (typeof itemVal === 'string' && itemVal.trim() !== '') {
          searchdata.fixedcolumns[key] = itemVal.trim();
        }
      });
      // 组织权限等场景：合并行内 query（如 CP_C_ORGANIZATION_ID: [id...]）
      if (this.permissionMode && this.permissionQuery && typeof this.permissionQuery === 'object') {
        Object.keys(this.permissionQuery).forEach((key) => {
          const qVal = this.permissionQuery[key];
          if (qVal === '' || qVal === null || qVal === undefined) return;
          if (Array.isArray(qVal) && !qVal.length) return;
          searchdata.fixedcolumns[key] = qVal;
        });
      }
      return searchdata;
    },
    getList() {
      this.selection = [];
      if (this.permissionMode) {
        this.prevPermissionSelection = [];
      }
      this.agTableConfig.agLoading = true;
      const params = new FormData();
      params.append('searchdata', JSON.stringify(this.getSearchParams()));
      this.service.common.QueryList(params).then(({ data: res }) => {
        if (res.code === 0) {
          const data = res.datas || {};
          const { tabth, row, totalRowCount, defaultrange, selectrange } = data;
          const akCol = (tabth || []).find((item) => item && item.isak);
          this.akColname = (akCol && akCol.colname) || '';
          if (defaultrange) {
            this.agTableConfig.pagenation.pageSize = defaultrange;
          }
          if (selectrange && selectrange.length) {
            this.agTableConfig.pagenation.pageSizeOpts = selectrange;
          }
          this.agTableConfig.columnDefs = (tabth || []).map((item) => ({
            ...item,
            thAlign: 'center',
            tdAlign: item.type === 'NUMBER' ? 'right' : 'left',
          }));
          if (this.permissionMode && this.agTableConfig.columnDefs.length) {
            this.agTableConfig.columnDefs[0] = {
              ...this.agTableConfig.columnDefs[0],
              checkboxSelection: true,
              headerCheckboxSelection: true,
            };
          }
          this.agTableConfig.rowData = row || [];
          this.agTableConfig.pagenation.total = totalRowCount || 0;
        } else {
          this.agTableConfig.rowData = [];
          this.agTableConfig.pagenation.total = 0;
          this.$Message.error(res.message || '查询失败');
        }
      }).finally(() => {
        this.agTableConfig.agLoading = false;
        if (this.permissionMode) {
          this.calcPermissionTableHeight();
        }
      });
    },
    resetForm() {
      (this.searchFormConfig.formData || []).forEach((item) => {
        const key = item.value || (item.itemdata && item.itemdata.colname);
        if (!key) {
          return;
        }
        if (item.style === 'checkbox') {
          this.$set(this.searchFormConfig.formValue, key, false);
          this.$set(this.searchFormConfig.formValueName, key, '');
        } else if (item.style === 'select' && item.multiple) {
          const initVal = this.parseSelectDefaultValue(item.default);
          this.$set(this.searchFormConfig.formValue, key, initVal);
          this.$set(
            this.searchFormConfig.formValueName,
            key,
            initVal.length ? this.buildSelectDisplayLabels(initVal, item.options || []) : '',
          );
        } else if (item.style === 'dropSelect' && item.itemdata && item.itemdata.fkdisplay === 'mrp') {
          this.$set(this.searchFormConfig.formValue, key, []);
          this.$set(this.searchFormConfig.formValueName, key, '');
        } else {
          this.$set(this.searchFormConfig.formValue, key, '');
          this.$set(this.searchFormConfig.formValueName, key, '');
        }
      });
      this.agTableConfig.pagenation.current = 1;
      this.getList();
    },
    getRowId(row) {
      return row.ID && row.ID.val !== undefined ? row.ID.val : row.ID;
    },
    getRowField(row, field) {
      if (row[field] && row[field].val !== undefined) {
        return row[field].val;
      }
      return row[field];
    },
    openObject(id) {
      R3.store.commit('global/tabOpen', {
        type: 'V',
        tableName: this.tableName,
        label: this.pageDesc,
        tableId: this.tableId,
        id,
        query: {
          id,
          tableName: this.tableName,
          tabTitle: id === 'New' ? `${this.pageDesc}新增` : this.pageDesc,
        },
      });
    },
    handleDelete(action) {
      if (!this.selection.length) {
        this.$Message.warning('请选择数据！');
        return;
      }
      const ids = this.selection.map((item) => this.getRowId(item)).join(',');
      const params = {
        ids,
        table: this.tableName,
        objids: ids,
      };
      this.service.common.publicUrlParams(action || '/p/cs/batchDelete', params).then((res) => {
        if (res.data.code === 0) {
          this.$Message.success(res.data.message || '删除成功');
          this.getList();
        }
      });
    },
    handleExport() {
      const formdata = new FormData();
      const searchdata = this.getSearchParams();
      searchdata.startindex = 0;
      searchdata.range = this.agTableConfig.pagenation.pageSize;
      if (this.selection.length) {
        searchdata.fixedcolumns.ID = this.selection.map((item) => this.getRowId(item));
      }
      formdata.append('searchdata', JSON.stringify(searchdata));
      formdata.append('menu', this.pageDesc);
      formdata.append('filename', this.pageDesc);
      formdata.append('filetype', '.xlsx');
      formdata.append('showColumnName', true);
      this.loading = true;
      this.service.orderCenter.exportChannel(formdata).then((res) => {
        if (res.data.code === 0 && res.data.data !== null) {
          this.selection = [];
          window.dispatchEvent(new CustomEvent('addTask', { detail: { type: 'notice' } }));
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    isPermissionExist(id, exclude = this.isPermissionExclude) {
      let exists = false;
      let index = {};
      const store = this.localPermissionConds;
      if (store) {
        store.forEach((row, rowIndex) => {
          if (exists) return;
          if (row.length === 1 && row[0].colname === 'id') {
            const rowExclude = !!row[0].exclude;
            if (rowExclude !== !!exclude) return;
            row.forEach((item) => {
              const arr = String(item.value).split(',');
              const idx = arr.findIndex((val) => val === String(id));
              if (idx > -1) {
                exists = true;
                index = arr.length === 1 ? { rowIndex } : { rowIndex, idx };
              }
            });
          }
        });
      }
      return { isExist: exists, index };
    },
    flattenSelectionRows(arr) {
      return arr.map((item) => {
        const row = { ...item };
        Object.keys(row).forEach((key) => {
          if (row[key] && row[key].val !== undefined) {
            row[key] = row[key].val;
          }
        });
        return row;
      });
    },
    buildPermissionRowLabel(row) {
      const enameField = this.akColname || 'ENAME';
      return {
        label: this.getRowField(row, enameField),
        value: this.getRowId(row),
      };
    },
    resolveSelectOptionValue(v) {
      if (v && typeof v === 'object') {
        if (v.value !== undefined) return v.value;
        if (v.limitval !== undefined) return v.limitval;
        if (v.val !== undefined) return v.val;
      }
      return v;
    },
    resolveSelectOptionLabel(v, combobox = []) {
      if (v && typeof v === 'object') {
        if (v.label) return v.label;
        if (v.Label) return v.Label;
        if (v.limitdesc) return v.limitdesc;
        if (v.value !== undefined) v = v.value;
        else if (v.limitval !== undefined) v = v.limitval;
        else if (v.val !== undefined) v = v.val;
      }
      const raw = String(v).replace('=', '');
      if (!raw) return '';
      const opt = combobox.find((o) => o.value == raw || o.limitval == raw);
      return opt ? (opt.label || opt.limitdesc) : raw;
    },
    buildPermissionConddesc(coldesc, displayValue, display) {
      if (['OBJ_FK', 'OBJ_SELECT'].includes(display) || display === undefined) {
        return `${coldesc} 含有 ${displayValue}`;
      }
      return `${coldesc} = ${displayValue}`;
    },
    buildSearchPermissionConds(exclude = this.isPermissionExclude) {
      const formData = this.searchFormConfig.formData || [];
      const formValue = this.searchFormConfig.formValue || {};
      const formValueName = this.searchFormConfig.formValueName || {};
      const conds = [];

      formData.forEach((item) => {
        const colname = item.colname || item.value || (item.itemdata && item.itemdata.colname);
        if (!colname) return;

        let value = formValue[colname];
        if (value === '' || value === null || value === undefined) return;
        if (Array.isArray(value) && !value.length) return;

        const itemdata = item.itemdata || {};
        let display = itemdata.display || item.display || (item.style === 'select' ? 'OBJ_SELECT' : undefined);
        if (display === 'select') {
          display = 'OBJ_SELECT';
        } else if (!display || display === 'text') {
          display = 'INPUT';
        }
        const coldesc = itemdata.name || item.label || itemdata.fkdesc || colname;
        const combobox = item.options || itemdata.combobox || [];
        let displayValue = value;
        const isSelect = display === 'OBJ_SELECT' || item.style === 'select';

        if (Array.isArray(value)) {
          if (isSelect) {
            displayValue = formValueName[colname] || value.map((v) => this.resolveSelectOptionLabel(v, combobox)).filter(Boolean).join(',');
            if (!formValueName[colname] && displayValue) {
              this.$set(this.searchFormConfig.formValueName, colname, displayValue);
            }
          } else if (display === 'OBJ_FK' || item.style === 'dropSelect') {
            displayValue = formValueName[colname] || value.map(i => (i && i.Label) || i).join(',');
          } else if (['OBJ_DATE', 'OBJ_DATENUMBER', 'YearMonth', 'OBJ_DATETIME'].includes(display) || item.style === 'date') {
            displayValue = value.join('~');
            if (displayValue === '~') displayValue = '';
          } else {
            displayValue = value.join(',');
          }
        } else if (item.style === 'dropSelect' || display === 'OBJ_FK') {
          displayValue = formValueName[colname] || String(value);
        } else if (isSelect) {
          displayValue = formValueName[colname] || this.resolveSelectOptionLabel(value, combobox);
          if (!formValueName[colname] && displayValue) {
            this.$set(this.searchFormConfig.formValueName, colname, displayValue);
          }
        } else if (typeof value === 'boolean') {
          displayValue = value ? 'Y' : 'N';
        }

        if (!displayValue || (typeof displayValue === 'string' && !displayValue.length)) return;

        const conddesc = this.buildPermissionConddesc(coldesc, displayValue, display);

        let storeValue = value;
        if (Array.isArray(value)) {
          if (item.style === 'date' || ['OBJ_DATE', 'OBJ_DATENUMBER', 'YearMonth', 'OBJ_DATETIME'].includes(display)) {
            storeValue = value.join('~');
          } else if (isSelect) {
            storeValue = value.map((v) => this.resolveSelectOptionValue(v)).join(',');
          } else {
            storeValue = value.join(',');
          }
        } else if (isSelect) {
          storeValue = this.resolveSelectOptionValue(value);
        }

        conds.push({
          coldesc,
          colname,
          value: storeValue,
          display,
          ...(display === 'OBJ_FK' ? {
            table: item.reftable || itemdata.reftable || this.tableName,
          } : {}),
          conddesc,
          label: conddesc,
          ...(exclude ? { exclude: true } : {}),
        });
      });

      return conds;
    },
    async PERMISSION_ADD_ALL() {
      const conds = this.buildSearchPermissionConds();
      if (!conds.length) {
        this.$Message.warning('请先填写筛选条件');
        return;
      }
      conds.forEach((cond) => {
        this.$set(cond, 'label', cond.conddesc || cond.label);
      });
      this.updateLocalPermissionConds({ data: conds });
      this.emitPermissionCondsChange();
    },
    getPermissionRowId(row) {
      const id = this.getRowId(row);
      if (id === '' || id === null || id === undefined) return '';
      return String(id);
    },
    getPermissionRowIds(rows) {
      return rows.map(row => this.getPermissionRowId(row)).filter(Boolean).sort().join(',');
    },
    handlePermissionSelectionChange(newSelection) {
      if (this._syncingPermissionSelection) {
        this.prevPermissionSelection = _.cloneDeep(newSelection);
        return;
      }
      const oldSelection = _.cloneDeep(this.prevPermissionSelection);
      const newRows = this.flattenSelectionRows(newSelection).filter(row => this.getPermissionRowId(row));
      const oldRows = this.flattenSelectionRows(oldSelection).filter(row => this.getPermissionRowId(row));

      if (this.getPermissionRowIds(newRows) === this.getPermissionRowIds(oldRows)) {
        this.prevPermissionSelection = _.cloneDeep(newSelection);
        return;
      }

      let payload = null;
      if (newRows.length > oldRows.length) {
        const select = $utils.getDifferentArr(newRows, oldRows, 'ID');
        const selectArr = [];
        select.forEach((row) => {
          const rowId = this.getPermissionRowId(row);
          if (!rowId || this.isPermissionExist(rowId).isExist) return;
          const { label, value } = this.buildPermissionRowLabel(row);
          if (!value) return;
          const idName = label || value || '';
          const idCond = {
            colname: 'id',
            label: idName,
            value,
            conddesc: idName,
          };
          if (this.isPermissionExclude) {
            idCond.exclude = true;
          }
          selectArr.push([idCond]);
        });
        if (!selectArr.length) {
          // 条件侧已有对应项时仍同步勾选快照，避免后续再勾选失效
          this.prevPermissionSelection = _.cloneDeep(newSelection);
          return;
        }
        payload = {
          isId: true,
          data: selectArr,
        };
      } else if (newRows.length < oldRows.length) {
        const select = $utils.getDifferentArr(oldRows, newRows, 'ID');
        const indexArr = [];
        select.forEach((row) => {
          const rowId = this.getPermissionRowId(row);
          const { isExist, index } = this.isPermissionExist(rowId);
          if (isExist) {
            indexArr.push(index.rowIndex);
          }
        });
        if (!indexArr.length) {
          // 右侧已移除时条件中可能已无该项，仍需同步勾选快照以便再次勾选能写入
          this.prevPermissionSelection = _.cloneDeep(newSelection);
          return;
        }
        payload = {
          isDel: true,
          data: indexArr,
        };
      } else {
        return;
      }
      this.updateLocalPermissionConds(payload);
      this.prevPermissionSelection = _.cloneDeep(newSelection);
      this.emitPermissionCondsChange();
    },
    emitPermissionCondsChange() {
      this.$emit('conds-change', _.cloneDeep(this.localPermissionConds));
    },
    onSelectionChange(selection) {
      if (this.permissionMode) {
        this.handlePermissionSelectionChange(selection);
        return;
      }
      this.selection = selection;
    },
    onRowDblclick(row) {
      if (this.permissionMode) {
        return;
      }
      const id = this.getRowId(row);
      if (id) {
        this.openObject(id);
      }
    },
    pageChange(val) {
      this.agTableConfig.pagenation.current = val;
      this.getList();
    },
    pageSizeChange(val) {
      this.agTableConfig.pagenation.pageSize = val;
      this.agTableConfig.pagenation.current = 1;
      this.getList();
    },
  },
};

</script>

<style lang="less" scoped>
.stand-list {
  .list-form {
    .btn-wrap {
      flex-direction: column;

      .business-form-main {
        border: none;
        padding-bottom: 0;
        /deep/ #dropMultiSelectFilter {
          font-size: 0;
          .ark-fkrp-select-icon {
            top: 4px;
          }
          .ark-input[disabled] {
            color: inherit;
          }
        }

        /deep/ .cusForm-content {
          max-height: 174px;
          overflow-y: auto;
        }

        /deep/ .ark-form-item.popSelect {
          .ark-select-selection-head {
            font-size: 0;
          }
        }
      }

      /deep/ .button-combina .button-content {
        justify-content: end;
      }

      .permission-exclude-check {
        margin-right: 8px;
        white-space: nowrap;
      }

      .btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  .list-table {
    position: relative;

    .tableBox {
      // min-height: 400px;
    }
  }

  &.permission-embed {
    height: 100%;

    .list-main {
      height: 100%;
    }

    .list-table .tableBox {
      // min-height: calc(80vh - 160px);
    }
  }
}

</style>
